package navigation.settings.general

import com.mohamedrejeb.calf.core.PlatformContext
import com.mohamedrejeb.calf.io.KmpFile

sealed interface GeneralEvent {
    data object GetLogo : GeneralEvent
    data class UpdateLogo(
        val file: KmpFile,
        val context: PlatformContext,
    ) : GeneralEvent

    data object DeleteLogo : GeneralEvent
}